import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Question, QuestionOption } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-test-step-circle',
    templateUrl: './test-step-circle.component.html',
    styleUrls: ['./test-step-circle.component.scss'],
})
export class TestStepCircleComponent extends BaseUI implements AfterViewInit, OnChanges, OnDestroy {
    public selected: QuestionOption;
    public stepNumber: number;

    @Input()
    question: Question;

    @Input()
    step: string;

    @Input()
    totalSteps: number;

    @Input()
    disabledOptions: number[] = [];

    @Input()
    hideBack = false;

    @Output()
    public next: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public back: EventEmitter<boolean> = new EventEmitter();

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    get isLastQuestion(): boolean {
        return this.stepNumber === this.totalSteps;
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('step' in changes && changes.step.currentValue) {
            this.stepNumber = Math.round(Number(this.step));
        }

        if ('question' in changes && changes.question.currentValue) {
            this.selected = undefined;
            this.question.options.map((option) => {
                if (option.selected) {
                    this.selected = option;
                }
            });
        }
    }

    isDisabled(idx: number): boolean {
        return this.disabledOptions.indexOf(idx) !== -1;
    }

    onBack() {
        this.back.emit(true);
    }

    onClick() {
        this.next.emit(true);
    }

    onSelectedChange() {
        this.question.options.map((option) => {
            option.selected = String(option.id) === String(this.selected.id);
        });
    }
}
